<template>
  <v-card class="pa-4">
    <div class="d-flex justify-end">
      <v-btn class="mb-4 mr-2" color="green" dark outlined @click="() => $refs['popup-import'].openDialog()">
        Nhập/xuất Excel học sinh
      </v-btn>
      <v-btn color="primary" @click="() => $refs['popup-add-students'].openDialog()">
        <v-icon left>add</v-icon> Thêm học sinh
      </v-btn>
    </div>
    <StudentTable class="mt-4" />
    <PopupImport ref="popup-import" />
    <PopupAddStudents ref="popup-add-students" />
  </v-card>
</template>
<script>
import PopupAddStudents from './PopupAddStudents.vue'
import PopupImport from './PopupImport.vue'
import StudentTable from './StudentTable.vue'

export default {
  components: { StudentTable, PopupImport, PopupAddStudents },
}
</script>